import {Agreement} from '@soluto-private/mx-context-types';

import {contextStateEvents} from '../storage';

/** @deprecated remove after mx-plans is refactored 1/13/2022 OSUE 199 */
export interface State {
    /**
     * Should be deprecated once mx-data will be ready, don't use unless you have to
     *
     * @param key
     * @param value
     *
     */

    set(key: StateKey, value: unknown): void;
    get(key: StateKey): Agreement[];
}

// Do not add enum values - should be deprecated once mx-data will be ready
/** @deprecated agreements found in verified + unverified plans */
export enum StateKey {
    Agreements = 'agreements',
    UnverifiedAgreements = 'unverifiedagreements',
}

let state: Record<StateKey, Agreement[]> = {
    [StateKey.Agreements]: [],
    [StateKey.UnverifiedAgreements]: [],
};

/** @deprecated remove after mx-plans is refactored 1/13/2022 OSUE 199 */
export const contextState: State = {
    set: (key: StateKey, value: Agreement[]) => {
        state[key] = value;
        document.dispatchEvent(new Event(contextStateEvents.stateUpdated));
    },
    get: (key: StateKey) => state[key],
};
